/* eslint-disable no-case-declarations */
import {
  GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS,
  GET_APPRAISALS_SUCCESS,
  GET_EQUITY_SUCCESS,
  GET_HOMESALE_INFO_SUCCESS,
  GET_INSPECTIONS_SUCCESS,
  GET_LISTINGS_SUCCESS,
  POST_HOMESALE_INFO_SUCCESS,
  UPDATE_APPRAISALS_SUCCESS,
  UPDATE_EQUITY_SUCCESS,
  UPDATE_HOMESALE_INFO_SUCCESS,
  UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS,
  UPDATE_LISTINGS_SUCCESS,
  GET_SPREAD_SELECTION_SUCCESS,
  UPDATE_SPREAD_SELECTION_SUCCESS,
  POST_LISTINGS_SUCCESS,
  POST_EQUITY_SUCCESS,
  UPDATE_TAX_SUCCESS,
  POST_TAX_SUCCESS,
  DELETE_TAX_SUCCESS,
  UPDATE_CREDIT_SUCCESS,
  POST_CREDIT_SUCCESS,
  DELETE_CREDIT_SUCCESS,
  DELETE_EQUITY_SUCCESS,
  GET_BUYOUT_SUCCESS,
  POST_BUYOUT_SUCCESS,
  UPDATE_BUYOUT_SUCCESS,
  UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  POST_HOMESALE_MORTGAGE_INFO_SUCCESS,
  DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  GET_HOMESALE_MORTGAGE_INFO_SUCCESS,
  GET_APPRAISALS_PREFERENCES_SUCCESS,
  POST_APPRAISALS_PREFERENCES_SUCCESS,
  UPDATE_APPRAISALS_PREFERENCES_SUCCESS
} from '../types/homesaleTypes';

const handleHomesaleReducer = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].homesale)
    draft.authorizationDetails[draft.currentAuthId].homesale = {};

  switch (action.type) {
    case POST_HOMESALE_INFO_SUCCESS:
    case UPDATE_HOMESALE_INFO_SUCCESS:
    case UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS:
    case GET_HOMESALE_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale = action.response;
      break;

    case GET_APPRAISALS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.appraisalsBmas = action.response;
      break;

    case GET_APPRAISALS_PREFERENCES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.appraisalPreferences = action.response;
      break;

    case POST_APPRAISALS_PREFERENCES_SUCCESS:
    case UPDATE_APPRAISALS_PREFERENCES_SUCCESS:
      let tempAppraisalPreferences = draft.authorizationDetails[draft.currentAuthId].homesale.appraisalPreferences;
      const tempAppraisalPreferencesIndex = tempAppraisalPreferences.findIndex(e => e.homesaleAppraisalPreferenceId === action.response.homesaleAppraisalPreferenceId);
      tempAppraisalPreferences[tempAppraisalPreferencesIndex] = action.response;
      draft.authorizationDetails[draft.currentAuthId].homesale.appraisalPreferences = tempAppraisalPreferences;
      break;

    case GET_SPREAD_SELECTION_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.spreadSelection = action.response;
      break;

    case UPDATE_APPRAISALS_SUCCESS:
      let tempAppraisals = draft.authorizationDetails[draft.currentAuthId].homesale.appraisalsBmas;
      const tempAppraisalIndex = tempAppraisals.findIndex(e => e.homesaleAppraisalId === action.response.homesaleAppraisalId);
      tempAppraisals[tempAppraisalIndex] = action.response;
      draft.authorizationDetails[draft.currentAuthId].homesale.appraisalsBmas = tempAppraisals;
      break;

    case UPDATE_SPREAD_SELECTION_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.spreadSelection = action.response;
      break;

    case GET_INSPECTIONS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.inspections = action.response;
      break;

    case GET_LISTINGS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.listings = action.response;
      break;

    case UPDATE_LISTINGS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.listings = action.response;
      break;

    case UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case POST_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case GET_HOMESALE_MORTGAGE_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.mortgages = action.response;
      break;

    case UPDATE_BUYOUT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.homesaleBuyout = action.response;
      break;

    case POST_BUYOUT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.homesaleBuyout = action.response;
      break;
    
    case POST_LISTINGS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.listings = action.response;
      break;

    case GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.resaleOffers = action.response;
      break;

    case GET_EQUITY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authHomesale.equities = action.response;
      break;

    case UPDATE_EQUITY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.equities = action.response;
      break;

    case POST_EQUITY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.equities = action.response;
      break;

    case DELETE_EQUITY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.equities = action.response;
      break;

    case UPDATE_TAX_SUCCESS:
      const updateTaxIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[updateTaxIndex].taxes = action.response;
      break;

    case POST_TAX_SUCCESS:
      const postTaxIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[postTaxIndex].taxes = action.response;
      break;

    case DELETE_TAX_SUCCESS:
      const deleteTaxIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[deleteTaxIndex].taxes = action.response;
      break;

    case UPDATE_CREDIT_SUCCESS:
      const updateCreditIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[updateCreditIndex].creditCharges = action.response;
      break;

    case POST_CREDIT_SUCCESS:
      const postCreditIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[postCreditIndex].creditCharges = action.response;
      break;

    case DELETE_CREDIT_SUCCESS:
      const deleteCreditIndex = draft.authorizationDetails[draft.currentAuthId].homesale.equities.findIndex((equity) => equity.equityInfo.homesaleEquityId === action.payload.homesaleEquityId);
      draft.authorizationDetails[draft.currentAuthId].homesale.equities[deleteCreditIndex].creditCharges = action.response;
      break;

    case GET_BUYOUT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].homesale.homesaleBuyout = action.response;
      break;

    default:
      break;
  }

  return draft;
};

export default handleHomesaleReducer;
